module.exports = __webpack_public_path__ + "static/media/engineirpd1.6ab4de82.svg";